import styled from 'styled-components';
import { theme } from '../theme/theme';

const Style = styled.div`
    #navigation {
        width: 100%;
        height: 60px;
        position: fixed;
        bottom: 0;
        box-shadow: 4px 0 10px 0 rgba(199, 199, 199, 0.712);
        z-index: 200;
        > div {
            position: relative;
            bottom: 4px;
        }
        .navbar {
            position: relative;
            background-repeat: no-repeat;
            background-position: center;
            background-size: 26px;
            background-color: #fff;
            color: #818894;
            min-width: 35px;
            min-height: 25px;
            font-size: 12px;
            max-height: 50px;
            &.home {
                background-image: url('/assets/icons/home.svg');
                &Active {
                    background-image: url('/assets/icons/active-home.svg');
                }
            }
            &.plans {
                background-image: url('/assets/icons/document.svg');
                &Active {
                    background-image: url('/assets/icons/active-document.svg');
                }
            }
            &.financial {
                background-image: url('/assets/icons/wallet.svg');
                &Active {
                    background-image: url('/assets/icons/active-wallet.svg');
                }
            }
            &.more {
                background-image: url('/assets/icons/more.svg');
                &Active {
                    background-image: url('/assets/icons/active-more.svg');
                }
            }
            p {
                position: absolute;
                top: 25px;
                left: 50%;
                transform: translateX(-50%);
                color: ${theme.gray};
                width: 100%;
            }
        }
        .message {
            background-image: url('/assets/icons/send.svg'),
                linear-gradient(to top, #1acc56, #82ffad);
            height: 50px;
            width: 50px;
            max-width: 50px;
            max-height: 50px;
            transform: rotate(-45deg);
            bottom: 20px;
            &Active {
                background-image: url('/assets/icons/active-send.svg'),
                    linear-gradient(to top, #1acc56, #82ffad);
            }
        }
        [class$='Active'] p {
            color: ${theme.primaryColor}!important;
        }
    }
`;

export default Style;
